module.exports = __webpack_public_path__ + "static/media/EyeofSkadi.7631b706.png";